import React from "react";
import { Link } from "react-router-dom";

function DataScience() {
  return (
    <div>
      {/* Breadcrumb Section */}
      <section className="course-breadcrumb-bar">
        <div className="container">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/">HOME</Link>
            <span className="breadcrumb-separator">&gt;</span>
            <Link to="/courses">COURSES</Link>
            <span className="breadcrumb-separator">&gt;</span>
            <span className="breadcrumb-current">DATA SCIENCE</span>
          </nav>
        </div>
      </section>
      <section className="course-page-hero">
        <div className="container">
          <div className="course-hero-grid">
            {/* Hero Content */}
            <div className="course-hero-content">
              <span className="section-badge">ANALYTICS PROGRAM</span>
              <h1 className="course-hero-title">
                Data Science &amp; Analytics
              </h1>
              <p className="course-hero-desc">
                Unlock the power of data. Learn Python, statistical analysis,
                data visualization, SQL, and business intelligence to make
                data-driven decisions that matter.
              </p>
              <div className="course-hero-meta">
                <div className="course-hero-meta-item">
                  <i className="fas fa-clock"></i> 3 Months
                </div>
                <div className="course-hero-meta-item">
                  <i className="fas fa-signal"></i> Beginner to Intermediate
                </div>
                <div className="course-hero-meta-item">
                  <i className="fas fa-laptop-house"></i> Online &amp; On-site
                </div>
                <div className="course-hero-meta-item">
                  <i className="fas fa-certificate"></i> Certificate Included
                </div>
              </div>
              <div className="course-hero-buttons">
                <Link
                  to="/enroll?course=DataScience"
                  className="btn btn-primary"
                >
                  Enroll Now <i className="fas fa-arrow-right"></i>
                </Link>
                <a
                  href="https://api.whatsapp.com/send/?phone=9779766715768&text=Hi%21+I'm+interested+in+the+Data+Science+course.&type=phone_number&app_absent=0"
                  className="btn btn-outline-dark"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp"></i> Ask on WhatsApp
                </a>
              </div>
            </div>

            {/* Hero Image */}
            <div className="course-hero-image">
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=700&h=500&fit=crop"
                alt="Data Science course at Leafclutch Technologies Nepal"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="course-section">
        <div className="container">
          {/* Section Header */}
          <div className="course-section-header">
            <span className="section-badge">REQUIREMENTS</span>
            <h2 className="section-title">What You Need to Get Started</h2>
            <p className="section-desc">
              New to data science? No worries — this program is designed for
              absolute beginners.
            </p>
          </div>

          {/* Requirements Grid */}
          <div className="requirements-grid">
            {/* Beginner Card */}
            <div className="requirements-card beginner-card">
              <h3>
                <i className="fas fa-seedling"></i> Beginner Friendly
              </h3>
              <ul>
                <li>
                  <i className="fas fa-check"></i> No prior programming or
                  statistics experience needed
                </li>
                <li>
                  <i className="fas fa-check"></i> Basic computer and
                  spreadsheet skills
                </li>
                <li>
                  <i className="fas fa-check"></i> Curiosity about data and
                  patterns
                </li>
                <li>
                  <i className="fas fa-check"></i> High school math is helpful
                  but not required
                </li>
              </ul>
            </div>

            {/* Technical Card */}
            <div className="requirements-card">
              <h3>
                <i className="fas fa-tools"></i> Technical Requirements
              </h3>
              <ul>
                <li>
                  <i className="fas fa-check"></i> A laptop with at least 4GB
                  RAM
                </li>
                <li>
                  <i className="fas fa-check"></i> Stable internet connection
                </li>
                <li>
                  <i className="fas fa-check"></i> Python &amp; Jupyter Notebook
                  (installed in first session)
                </li>
                <li>
                  <i className="fas fa-check"></i> Google Colab (free) as a
                  cloud alternative
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="course-section">
        <div className="container">
          {/* Section Header */}
          <div className="course-section-header">
            <span className="section-badge">CURRICULUM</span>
            <h2 className="section-title">Course Content</h2>
            <p className="section-desc">
              Master Data Analysis with Python, Statistics, SQL, Power BI,
              Tableau, EDA, Feature Engineering &amp; real-world projects.
            </p>
          </div>

          {/* Curriculum Accordion */}
          <div className="curriculum-accordion-wrapper">
            <div className="curriculum-stats">
              <span className="curriculum-stats-text">
                <strong>8 sections</strong> • 24 lectures • 3 months total
                length
              </span>
              <button className="curriculum-expand-btn">
                Expand all sections
              </button>
            </div>

            {/* Section: Python for Data Analysis */}
            <div className="curriculum-section-item active">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Python for Data Analysis
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Python basics, data types &amp; control flow
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Pandas, NumPy &amp; essential libraries
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Data manipulation &amp; analysis with Python
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: Statistics & Probability */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Statistics &amp; Probability
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Descriptive statistics &amp; distributions
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Probability distribution functions
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Inferential stats &amp; hypothesis testing
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: Feature Engineering */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Feature Engineering
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Handling missing data &amp; encoding
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Feature scaling &amp; selection techniques
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Data preprocessing &amp; transformation
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: Exploratory Data Analysis */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Exploratory Data Analysis
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Data visualization with Matplotlib &amp; Seaborn
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Identifying trends, patterns &amp; outliers
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Storytelling with data visualizations
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: SQL & Database Management */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  SQL &amp; Database Management
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      SQL fundamentals to advanced queries
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      SQL Server, JOINs &amp; aggregation
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Working with large datasets efficiently
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: Power BI & Tableau */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Power BI &amp; Tableau
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Interactive dashboards &amp; DAX calculations
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Data transformations &amp; reporting
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Tableau visualization &amp; business insights
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: Excel & ETL Pipelines */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Excel &amp; ETL Pipelines
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Advanced Excel for data analysis
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      ETL processes &amp; data workflows
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      AWS &amp; Snowflake cloud analytics
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section: Capstone Projects */}
            <div className="curriculum-section-item">
              <button className="curriculum-section-header-btn">
                <i className="fas fa-chevron-right curriculum-section-chevron"></i>
                <span className="curriculum-section-title">
                  Capstone Projects
                </span>
                <span className="curriculum-section-meta">3 lectures</span>
              </button>
              <div className="curriculum-section-body">
                <ul className="curriculum-lecture-list">
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      End-to-end data analysis projects
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Real-world dataset analysis &amp; reporting
                    </span>
                  </li>
                  <li className="curriculum-lecture-item">
                    <i className="fas fa-play-circle curriculum-lecture-icon"></i>
                    <span className="curriculum-lecture-name">
                      Portfolio building &amp; career preparation
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Recommended Udemy Course */}
          <div className="recommended-course-card">
            <div className="recommended-course-icon">
              <i className="fas fa-graduation-cap"></i>
            </div>
            <div className="recommended-course-content">
              <div className="recommended-course-label">
                Recommended Udemy Course
              </div>
              <div className="recommended-course-title">
                Complete Data Analyst Bootcamp: From Basics to Advanced by Krish
                Naik
              </div>
              <p className="recommended-course-note">
                We recommend this course for our training. If you prefer a
                different Udemy course, let us know — we'll provide that one
                instead.
              </p>
            </div>
            <a
              href="https://www.udemy.com/course/complete-data-analyst-bootcamp-from-basics-to-advanced/"
              className="recommended-course-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-external-link-alt"></i> View on Udemy
            </a>
          </div>
        </div>
      </section>
      <section className="course-section">
        <div className="container">
          {/* Section Header */}
          <div className="course-section-header">
            <span className="section-badge">OUTCOMES</span>
            <h2 className="section-title">What You'll Be Able to Do</h2>
          </div>

          {/* Outcomes Grid */}
          <div className="outcomes-grid">
            <div className="outcome-card">
              <div className="outcome-icon">
                <i className="fab fa-python"></i>
              </div>
              <h3>Write Python Code</h3>
              <p>Use Python confidently for data analysis and automation.</p>
            </div>

            <div className="outcome-card">
              <div className="outcome-icon">
                <i className="fas fa-table"></i>
              </div>
              <h3>Wrangle Data</h3>
              <p>Clean, transform, and prepare messy datasets for analysis.</p>
            </div>

            <div className="outcome-card">
              <div className="outcome-icon">
                <i className="fas fa-chart-bar"></i>
              </div>
              <h3>Visualize Insights</h3>
              <p>
                Create compelling charts, graphs, and interactive dashboards.
              </p>
            </div>

            <div className="outcome-card">
              <div className="outcome-icon">
                <i className="fas fa-database"></i>
              </div>
              <h3>Query Databases</h3>
              <p>
                Write SQL queries to extract and analyze data from databases.
              </p>
            </div>

            <div className="outcome-card">
              <div className="outcome-icon">
                <i className="fas fa-briefcase"></i>
              </div>
              <h3>Portfolio Ready</h3>
              <p>Complete a real-world analytics project for your portfolio.</p>
            </div>

            <div className="outcome-card">
              <div className="outcome-icon">
                <i className="fas fa-certificate"></i>
              </div>
              <h3>Industry Certificate</h3>
              <p>
                Receive a recognized certificate from Leafclutch Technologies.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="enroll-benefits-section">
        <div className="container">
          {/* Section Header */}
          <div className="enroll-benefits-header">
            <span className="section-badge">AFTER ENROLLMENT</span>
            <h2 className="section-title">What You'll Get</h2>
            <p className="section-desc">
              From day one, you'll have access to resources and support that set
              you up for success.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="enroll-benefits-grid">
            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fab fa-youtube"></i>
              </div>
              <h3>Lifetime Udemy Course</h3>
              <p>
                Get a premium Udemy course related to your chosen training
                program — yours to keep forever.
              </p>
              <span className="enroll-benefit-highlight">Premium</span>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-user-tie"></i>
              </div>
              <h3>Dedicated Mentor Support</h3>
              <p>
                Get guidance from experienced industry mentors who'll help you
                every step of the way.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3>Company Workflow Experience</h3>
              <p>
                Understand how a real IT company operates — from project
                planning to deployment.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-calendar-alt"></i>
              </div>
              <h3>1 Month Training + 2 Months Internship</h3>
              <p>
                One month of intensive training followed by two months of
                hands-on training and internship opportunity.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-network-wired"></i>
              </div>
              <h3>Connections &amp; Exposure</h3>
              <p>
                Build your professional network and gain valuable industry
                exposure through real projects.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-briefcase"></i>
              </div>
              <h3>Potential Job Offer</h3>
              <p>
                Best performing candidates can receive a direct job offer from
                Leafclutch Technologies.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="enroll-benefits-section enroll-benefits-section--alt">
        <div className="container">
          {/* Section Header */}
          <div className="enroll-benefits-header">
            <span className="section-badge">AFTER COMPLETION</span>
            <h2 className="section-title">What You'll Walk Away With</h2>
            <p className="section-desc">
              Complete the program and leave with tangible skills, credentials,
              and opportunities.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="enroll-benefits-grid">
            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-award"></i>
              </div>
              <h3>Completion Certificate</h3>
              <p>
                Receive an official completion certificate from Leafclutch
                Technologies for your portfolio.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-certificate"></i>
              </div>
              <h3>Training &amp; Internship Certificates</h3>
              <p>
                Get separate training certificate and internship certificate to
                showcase your experience.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Company &amp; Tools Knowledge</h3>
              <p>
                Gain real understanding of how companies run and hands-on
                experience with industry tools.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-laptop-code"></i>
              </div>
              <h3>Professional Experience</h3>
              <p>
                Add real professional work experience to your resume — not just
                theory, but actual project work.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-hands-helping"></i>
              </div>
              <h3>Ongoing Team Support</h3>
              <p>
                Our team continues to support you even after the program —
                career advice, referrals, and more.
              </p>
            </div>

            <div className="enroll-benefit-card">
              <div className="enroll-benefit-icon">
                <i className="fas fa-user-check"></i>
              </div>
              <h3>Direct Job Offer</h3>
              <p>
                If a vacancy is available, you can get a direct job offer — no
                interview needed.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="course-cta">
        <div className="course-cta-content">
          <h2>Turn Data Into Decisions</h2>
          <p>
            Start your data science career with hands-on training. No prior
            experience needed — we'll guide you every step.
          </p>
          <div className="cta-buttons">
            <Link to="/enroll?course=DataScience" className="btn btn-primary">
              Enroll Now <i className="fas fa-arrow-right"></i>
            </Link>
            <a
              href="https://api.whatsapp.com/send/?phone=9779766715768&text=Hi%21+I%27m+interested+in+the+Data+Science+course.&type=phone_number&app_absent=0"
              className="btn btn-outline-light"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i> Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DataScience;
